var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _path2, _g11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbotBear({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 83.324 83.5201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 3 16 L 79 16 L 79 77 L 3 77 Z M 3 16 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 1.339844 41.425781 C 1.339844 63.507812 19.242188 81.410156 41.328125 81.410156 C 63.410156 81.410156 81.3125 63.507812 81.3125 41.425781 C 81.3125 19.339844 63.410156 1.4375 41.328125 1.4375 C 19.242188 1.4375 1.339844 19.339844 1.339844 41.425781 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-2"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 30 32 L 36 32 L 36 38 L 30 38 Z M 30 32 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-3"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 1.339844 41.425781 C 1.339844 63.507812 19.242188 81.410156 41.328125 81.410156 C 63.410156 81.410156 81.3125 63.507812 81.3125 41.425781 C 81.3125 19.339844 63.410156 1.4375 41.328125 1.4375 C 19.242188 1.4375 1.339844 19.339844 1.339844 41.425781 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-4"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 48 32 L 54 32 L 54 38 L 48 38 Z M 48 32 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-5"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 1.339844 41.425781 C 1.339844 63.507812 19.242188 81.410156 41.328125 81.410156 C 63.410156 81.410156 81.3125 63.507812 81.3125 41.425781 C 81.3125 19.339844 63.410156 1.4375 41.328125 1.4375 C 19.242188 1.4375 1.339844 19.339844 1.339844 41.425781 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-6"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 36 41 L 48 41 L 48 49 L 36 49 Z M 36 41 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-7"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 1.339844 41.425781 C 1.339844 63.507812 19.242188 81.410156 41.328125 81.410156 C 63.410156 81.410156 81.3125 63.507812 81.3125 41.425781 C 81.3125 19.339844 63.410156 1.4375 41.328125 1.4375 C 19.242188 1.4375 1.339844 19.339844 1.339844 41.425781 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-8"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 29 38 L 55 38 L 55 56 L 29 56 Z M 29 38 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-9"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 1.339844 41.425781 C 1.339844 63.507812 19.242188 81.410156 41.328125 81.410156 C 63.410156 81.410156 81.3125 63.507812 81.3125 41.425781 C 81.3125 19.339844 63.410156 1.4375 41.328125 1.4375 C 19.242188 1.4375 1.339844 19.339844 1.339844 41.425781 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-10"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 28 26 L 55 26 L 55 31 L 28 31 Z M 28 26 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-11"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 1.339844 41.425781 C 1.339844 63.507812 19.242188 81.410156 41.328125 81.410156 C 63.410156 81.410156 81.3125 63.507812 81.3125 41.425781 C 81.3125 19.339844 63.410156 1.4375 41.328125 1.4375 C 19.242188 1.4375 1.339844 19.339844 1.339844 41.425781 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-12"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 16 45 L 29 45 L 29 56 L 16 56 Z M 16 45 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-13"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 1.339844 41.425781 C 1.339844 63.507812 19.242188 81.410156 41.328125 81.410156 C 63.410156 81.410156 81.3125 63.507812 81.3125 41.425781 C 81.3125 19.339844 63.410156 1.4375 41.328125 1.4375 C 19.242188 1.4375 1.339844 19.339844 1.339844 41.425781 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-14"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 15 44 L 30 44 L 30 57 L 15 57 Z M 15 44 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-15"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 1.339844 41.425781 C 1.339844 63.507812 19.242188 81.410156 41.328125 81.410156 C 63.410156 81.410156 81.3125 63.507812 81.3125 41.425781 C 81.3125 19.339844 63.410156 1.4375 41.328125 1.4375 C 19.242188 1.4375 1.339844 19.339844 1.339844 41.425781 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-16"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 26 53 L 31 53 L 31 58 L 26 58 Z M 26 53 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-17"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 1.339844 41.425781 C 1.339844 63.507812 19.242188 81.410156 41.328125 81.410156 C 63.410156 81.410156 81.3125 63.507812 81.3125 41.425781 C 81.3125 19.339844 63.410156 1.4375 41.328125 1.4375 C 19.242188 1.4375 1.339844 19.339844 1.339844 41.425781 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-18"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 25 52 L 32 52 L 32 59 L 25 59 Z M 25 52 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-19"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 1.339844 41.425781 C 1.339844 63.507812 19.242188 81.410156 41.328125 81.410156 C 63.410156 81.410156 81.3125 63.507812 81.3125 41.425781 C 81.3125 19.339844 63.410156 1.4375 41.328125 1.4375 C 19.242188 1.4375 1.339844 19.339844 1.339844 41.425781 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-20"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 11 31 L 21 31 L 21 48 L 11 48 Z M 11 31 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-21"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 1.339844 41.425781 C 1.339844 63.507812 19.242188 81.410156 41.328125 81.410156 C 63.410156 81.410156 81.3125 63.507812 81.3125 41.425781 C 81.3125 19.339844 63.410156 1.4375 41.328125 1.4375 C 19.242188 1.4375 1.339844 19.339844 1.339844 41.425781 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-22"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 10 30 L 21 30 L 21 49 L 10 49 Z M 10 30 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-23"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 1.339844 41.425781 C 1.339844 63.507812 19.242188 81.410156 41.328125 81.410156 C 63.410156 81.410156 81.3125 63.507812 81.3125 41.425781 C 81.3125 19.339844 63.410156 1.4375 41.328125 1.4375 C 19.242188 1.4375 1.339844 19.339844 1.339844 41.425781 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-24"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 0 0.0976562 L 82.652344 0.0976562 L 82.652344 82.945312 L 0 82.945312 Z M 0 0.0976562 "
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(3.921509%, 29.803467%, 56.471252%)",
    fillOpacity: 1,
    d: "M 1.339844 41.425781 C 1.339844 19.339844 19.242188 1.4375 41.328125 1.4375 C 63.410156 1.4375 81.3125 19.339844 81.3125 41.425781 C 81.3125 63.507812 63.410156 81.410156 41.328125 81.410156 C 19.242188 81.410156 1.339844 63.507812 1.339844 41.425781 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(100%, 100%, 100%)",
    fillOpacity: 1,
    d: "M 78.976562 76.621094 L 3.433594 76.621094 C 3.574219 74.839844 3.886719 74.945312 4.226562 73.273438 C 5.582031 66.648438 8.195312 62.40625 10.726562 58.304688 C 14.449219 52.265625 18.300781 46.023438 18.414062 31.84375 C 16.121094 30.980469 14.367188 27.742188 14.679688 24.835938 C 14.953125 22.296875 16.679688 20.742188 19.417969 20.570312 C 22.238281 20.40625 24.292969 22.425781 25.019531 23.257812 C 30.09375 18.332031 36.175781 16.121094 43.09375 16.671875 C 51.507812 17.34375 54.355469 18.804688 59.167969 23.390625 C 59.84375 22.148438 61.960938 19.144531 66.171875 20.382812 C 67.488281 20.769531 68.417969 21.640625 68.859375 22.90625 C 69.671875 25.238281 67.894531 28.121094 66.308594 32.085938 C 65.796875 33.359375 67.277344 43.929688 67.449219 45.164062 C 67.449219 45.164062 70.800781 57.261719 73.546875 62.050781 C 76.289062 66.839844 78.671875 73.429688 78.976562 76.621094 "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.56,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "rgb(1.568604%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00162105 0.00103663 C -0.277277 0.170368 -0.450546 0.481465 -0.493864 0.804377 C -0.572622 1.465951 -0.0410005 2.139339 0.620574 2.21416 C 1.282148 2.292918 1.951598 1.757358 2.026419 1.095784 C 2.050046 0.859508 2.010667 0.619293 1.920094 0.402707 C 1.742887 -0.022591 1.356969 -0.373068 0.900167 -0.451827 C 0.443366 -0.526647 -0.0606902 -0.302185 -0.261525 0.115237 C -0.375725 0.347575 -0.391477 0.619293 -0.371788 0.87526 C -0.324532 1.458075 -0.0764419 2.064518 0.427615 2.351987 C 0.935609 2.639457 1.715321 2.438622 1.872839 1.879435 C 1.963412 1.556523 1.841335 1.213922 1.715321 0.902825 C 1.4121 0.182182 1.065561 -0.514834 0.671767 -1.188222 C 0.60876 -1.290608 0.537877 -1.40087 0.423677 -1.428436 C 0.281911 -1.467815 0.144083 -1.361491 0.0377584 -1.255167 C -0.493864 -0.73142 -0.836465 0.0128505 -0.76952 0.753183 C -0.698637 1.497454 -0.159139 2.206284 0.56938 2.359863 C 1.301837 2.513443 2.136681 1.989697 2.219378 1.249364 C 2.254819 0.938267 2.164247 0.619293 2.022481 0.3397 C 1.841335 -0.026529 1.522362 -0.373068 1.112816 -0.400633 C 0.612698 -0.440013 0.171648 0.123113 0.329166 0.603542 C 0.482746 1.076095 1.171885 1.27693 1.553866 0.954018 C 1.589307 0.410583 1.404224 -0.140729 1.053747 -0.550275 C 0.978926 -0.63691 0.888354 -0.719607 0.778091 -0.719607 C 0.667829 -0.719607 0.581194 -0.640848 0.506373 -0.558151 C 0.199214 -0.219488 -0.0331246 0.225499 0.0141307 0.6823 C 0.065324 1.135164 0.478808 1.564399 0.931671 1.509268 C 1.388472 1.454137 1.668066 0.796501 1.321527 0.493279 ",
    transform: "matrix(0.991952, 0, 0, -0.991952, 32.142233, 35.727591)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.56,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "rgb(1.568604%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.000641033 0.00194481 C 0.217228 0.261849 0.630712 0.285477 0.937871 0.135835 C 1.241092 -0.013807 1.461617 -0.293401 1.6467 -0.58087 C 2.005053 -1.120368 2.300399 -1.829198 1.989301 -2.404137 C 1.595507 -3.140532 0.378683 -3.061773 -0.0899316 -2.372634 C -0.558547 -1.683494 -0.36165 -0.699009 0.169972 -0.0571243 C 0.280235 0.0767657 0.410187 0.20278 0.57558 0.257911 C 0.918181 0.379987 1.28441 0.167338 1.567942 -0.0531864 C 1.965674 -0.360346 2.363406 -0.785643 2.300399 -1.285762 C 2.241329 -1.789818 1.709707 -2.116667 1.201713 -2.191488 C 0.693719 -2.266309 0.177848 -2.163923 -0.330146 -2.203302 C -0.511291 -1.2897 0.0203307 -0.931347 0.000641033 0.00194481 C 1.083575 0.427242 1.745149 0.848602 2.702069 0.179152 C 2.835959 0.0846416 2.969849 -0.0295587 3.001352 -0.191014 C 3.021042 -0.301277 2.9856 -0.415477 2.946221 -0.525739 C 2.741448 -1.061299 2.324026 -1.581107 1.753025 -1.648052 C 1.300162 -1.699246 0.831547 -1.42359 0.658277 -1.006168 C 0.48107 -0.588746 0.618898 -0.0610622 0.973312 0.22247 C 1.095389 0.320918 1.248968 0.391801 1.406486 0.387863 C 1.859349 0.376049 2.06806 -0.210704 2.020805 -0.663567 C 1.977487 -1.045548 1.80028 -1.455093 1.441927 -1.592921 C 1.079637 -1.726811 0.59527 -1.352707 0.752788 -1.006168 C 0.792167 -0.927409 0.851236 -0.840775 0.811857 -0.765954 C 0.772477 -0.691133 0.63465 -0.817147 0.721284 -0.828961 ",
    transform: "matrix(0.991952, 0, 0, -0.991952, 49.62827, 33.884742)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.56,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "rgb(1.568604%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00146528 -0.00184484 C -0.435646 1.27011 -1.680036 2.167961 -3.007122 2.388485 C -4.334208 2.60901 -5.712487 2.223092 -6.866304 1.530014 C -7.500312 1.148034 -8.094942 0.655791 -8.425729 -0.00184484 C -8.760454 -0.663419 -8.780143 -1.517952 -8.335156 -2.104705 C -8.102817 -2.419741 -7.756279 -2.636327 -7.405802 -2.813535 C -5.149362 -3.959476 -2.247099 -3.699571 -0.230873 -2.175588 C 0.190486 -1.856615 0.600032 -1.447069 0.682729 -0.923323 C 0.785116 -0.285377 0.35588 0.348632 -0.19937 0.679419 C -0.754619 1.014144 -2.05414 -0.0412243 -2.613328 -0.368073 C -4.822513 -1.667594 -3.79471 0.565219 -4.519291 0.667605 C -5.216307 0.769992 -5.661294 1.719035 -6.326806 1.474883 C -6.992318 1.230731 -7.54363 0.521901 -7.354609 -0.1633 C -7.118332 -1.021772 -6.015709 -1.230482 -5.125734 -1.281676 C -4.322394 -1.324993 -3.515116 -1.36831 -2.707838 -1.415566 C -2.219533 -1.439193 -1.699725 -1.458883 -1.278366 -1.206855 C -0.860944 -0.954827 -0.640419 -0.324756 -0.979082 0.0296587 C -1.195669 0.261997 -1.546146 0.285625 -1.865119 0.297439 C -3.810462 0.364384 -5.78337 0.427391 -7.681458 -0.00578278 C -5.999957 -1.132034 -3.790772 -1.435255 -1.869057 -0.797309 C -3.007122 0.0493484 -4.594112 0.254121 -5.913322 -0.277501 C -4.070366 0.163549 -1.880871 0.517963 -0.494715 -0.777619 C -0.258439 -0.998144 -0.04579 -1.356497 -0.219059 -1.63609 C -0.31357 -1.793608 -0.502591 -1.868429 -0.683736 -1.927498 C -2.912611 -2.683583 -5.590411 -3.030122 -7.441243 -1.577021 C -7.929548 -1.191103 -8.30759 -0.379887 -7.799596 -0.0136587 C -7.65783 0.0847899 -7.480623 0.116293 -7.307353 0.143859 C -5.621915 0.395887 -3.897096 0.395887 -2.20772 0.143859 C -1.782422 0.0808519 -1.313807 -0.0294104 -1.089344 -0.395639 C -0.864882 -0.75793 -0.979082 -1.242296 -1.2508 -1.565207 C -1.51858 -1.888119 -1.916312 -2.081078 -2.30223 -2.242533 C -3.318219 -2.663893 -4.436594 -2.971052 -5.51559 -2.74659 C -6.594586 -2.526065 -7.594823 -1.647904 -7.653892 -0.549219 C -6.531579 -0.375949 -5.40139 -0.22237 -4.271201 -0.0884795 C -2.916549 0.0690381 -1.325621 0.112355 -0.435646 -0.923323 C -0.699488 -0.856378 -0.96333 -0.785495 -1.227172 -0.714612 ",
    transform: "matrix(0.991952, 0, 0, -0.991952, 45.635265, 44.638795)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.134,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "rgb(1.568604%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00178602 -0.000399146 C -3.809775 0.34614 -9.311079 -2.882972 -10.41764 -7.982606 C -11.528139 -13.082239 -7.75953 -14.409325 -3.99092 -15.519825 C -0.222311 -16.626386 5.318372 -16.626386 9.311445 -14.62985 C 13.300579 -12.637252 15.07659 -9.754679 11.969555 -5.320558 C 8.866457 -0.886436 4.877323 -0.441449 -0.00178602 -0.000399146 Z M -0.00178602 -0.000399146 ",
    transform: "matrix(0.991952, 0, 0, -0.991952, 40.423647, 38.921479)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-10)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-11)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(1.568604%, 0%, 0%)",
    fillOpacity: 1,
    d: "M 28.988281 26.539062 C 29.207031 26.015625 29.824219 25.929688 30.363281 26.144531 L 31.414062 26.566406 L 32.1875 26.902344 L 32.914062 27.183594 L 34.101562 27.597656 C 34.515625 27.75 35.171875 27.914062 35.527344 28.0625 C 35.828125 28.1875 35.941406 28.261719 36.234375 28.386719 C 36.769531 28.605469 37.019531 29.042969 36.792969 29.566406 C 36.625 29.957031 36.234375 30.191406 35.820312 30.191406 C 35.683594 30.191406 35.546875 30.164062 35.410156 30.109375 C 34.664062 29.757812 33.894531 29.519531 33.101562 29.183594 C 32.53125 28.945312 31.988281 28.753906 31.253906 28.570312 L 29.558594 27.875 C 29.019531 27.65625 28.765625 27.058594 28.988281 26.539062 M 47.609375 28.734375 L 49.097656 28.253906 L 50.75 27.601562 L 51.859375 27.15625 L 53.421875 26.519531 C 53.949219 26.28125 54.578125 26.179688 54.820312 26.691406 C 55.066406 27.203125 54.839844 27.8125 54.3125 28.050781 L 52.886719 28.523438 L 51.34375 29.265625 L 50.152344 29.691406 L 48.398438 30.46875 C 48.269531 30.519531 48.136719 30.546875 48.007812 30.546875 C 47.585938 30.546875 47.191406 30.304688 47.027344 29.90625 C 46.808594 29.378906 47.070312 28.945312 47.609375 28.734375 "
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-12)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-13)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(100%, 100%, 100%)",
    fillOpacity: 1,
    d: "M 28.320312 55.488281 C 17.710938 57.226562 16.332031 45.640625 16.332031 45.640625 "
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-14)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-15)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "rgb(13.33313%, 9.01947%, 7.843018%)",
    strokeOpacity: 1,
    strokeMiterlimit: 4,
    d: "M 0.000572608 0.00109286 C -10.694875 -1.751291 -12.084968 9.928642 -12.084968 9.928642 ",
    transform: "matrix(0.991952, 0, 0, -0.991952, 28.319744, 55.489365)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-16)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-17)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(13.33313%, 9.01947%, 7.843018%)",
    fillOpacity: 1,
    d: "M 26.632812 55.539062 C 26.632812 56.523438 27.429688 57.324219 28.417969 57.324219 C 29.402344 57.324219 30.203125 56.523438 30.203125 55.539062 C 30.203125 54.550781 29.402344 53.753906 28.417969 53.753906 C 27.429688 53.753906 26.632812 54.550781 26.632812 55.539062 "
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-18)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-19)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "rgb(13.33313%, 9.01947%, 7.843018%)",
    strokeOpacity: 1,
    strokeMiterlimit: 4,
    d: "M 0.000282075 -0.00110037 C 0.000282075 -0.993462 0.803622 -1.800739 1.799921 -1.800739 C 2.792282 -1.800739 3.59956 -0.993462 3.59956 -0.00110037 C 3.59956 0.995199 2.792282 1.798539 1.799921 1.798539 C 0.803622 1.798539 0.000282075 0.995199 0.000282075 -0.00110037 Z M 0.000282075 -0.00110037 ",
    transform: "matrix(0.991952, 0, 0, -0.991952, 26.632533, 55.537971)"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-20)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-21)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(68.235779%, 81.96106%, 92.156982%)",
    fillOpacity: 1,
    d: "M 17.839844 47.230469 L 20.109375 31.300781 C 16.378906 30.765625 13.039062 32.515625 12.648438 35.195312 L 11.757812 41.390625 C 11.367188 44.070312 14.109375 46.695312 17.824219 47.230469 Z M 17.839844 47.230469 "
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-22)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "rgb(13.33313%, 9.01947%, 7.843018%)",
    strokeOpacity: 1,
    strokeMiterlimit: 4,
    d: "M 0.000176773 0.00130024 L 2.288121 16.060224 C -1.472613 16.599722 -4.839553 14.835524 -5.233347 12.134097 L -6.131197 5.888522 C -6.524992 3.187095 -3.760557 0.540798 -0.015575 0.00130024 Z M 0.000176773 0.00130024 ",
    transform: "matrix(0.991952, 0, 0, -0.991952, 17.839668, 47.231759)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(100%, 100%, 100%)",
    fillOpacity: 1,
    d: "M 75.566406 62.089844 C 68.5625 73.671875 55.847656 81.410156 41.328125 81.410156 C 26.570312 81.410156 13.675781 73.414062 6.75 61.519531 Z M 75.566406 62.089844 "
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-24)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.703,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(3.921509%, 29.803467%, 56.471252%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00058622 -0.00101936 C -0.00058622 22.264099 18.046998 40.311683 40.312116 40.311683 C 62.573297 40.311683 80.620881 22.264099 80.620881 -0.00101936 C 80.620881 -22.2622 62.573297 -40.309784 40.312116 -40.309784 C 18.046998 -40.309784 -0.00058622 -22.2622 -0.00058622 -0.00101936 Z M -0.00058622 -0.00101936 ",
    transform: "matrix(0.991952, 0, 0, -0.991952, 1.340425, 41.42477)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotBear);
export default __webpack_public_path__ + "static/media/chatbot_bear.84a2c4f9e78678f98740c17ed1070f89.svg";
export { ForwardRef as ReactComponent };